import { render } from "./ContentSwitch.vue?vue&type=template&id=1e919fb6"
import script from "./ContentSwitch.vue?vue&type=script&lang=js"
export * from "./ContentSwitch.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__